import { getTrustpilotProductSkus } from "./get-trustpilot-product-skus";

interface ProductItem {
  name?: string;
  sku?: string;
}

interface RelatedProduct {
  relation?: string;
  frontendItems?: ProductItem[];
}

interface ProductDataLike {
  frontendItems?: ProductItem[];
  relatedProducts?: RelatedProduct[];
}

export function getTrustpilotSkusForProductData(
  productData: unknown,
): string[] {
  if (!productData || typeof productData !== "object") {
    return [];
  }
  const record = productData as ProductDataLike;
  return getTrustpilotProductSkus(
    [
      ...(record.frontendItems ?? []),
      ...(record.relatedProducts ?? [])
        .filter((rp) => rp?.relation === "variant")
        .flatMap((rp) => rp.frontendItems ?? []),
    ].filter(
      (item): item is { name?: string; sku: string } =>
        typeof item.sku === "string" && item.sku.length > 0,
    ),
  );
}
